module.exports = __webpack_public_path__ + "img/certificate2.768575d4.jpeg";